import styled from 'styled-components';
import { Text, theme } from '@veeqo/ui';

interface DividerProps {
  text?: string;
}

const Container = styled.div`
  width: 100%;
`;

const Content = styled.div<{ hasText: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${({ hasText }) => (hasText ? `0 ${theme.sizes[5]}` : '0 0')};
`;

const Line = styled.hr`
  width: 100%;
  border-top: 1px solid ${theme.colors.neutral.ink.lightest};
`;

const TextContent = styled(Text)`
  padding: 0 10px;
`;

const Divider = ({ text }: DividerProps) => (
  <Container>
    <Content hasText={Boolean(text)}>
      <Line />
      {text && (
        <>
          <TextContent variant="body">{text}</TextContent>
          <Line />
        </>
      )}
    </Content>
  </Container>
);

export default Divider;
